import { Project } from "@brg/api";
import { FC, useMemo } from "react";
import { useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import GridWithDifferentSizes from "./components/GridWithDifferentSizes";
import { PROJECTS_COLUMNS_DESKTOP_COUNT } from "shared/pages/designer/components/DesignerFolders/DesignerFolders";

const isWideProject = (project: Project) => {
    //@ts-ignore
    return !!['fixed-ratio-small', 'fixed-ratio-large', 't-shape']?.includes(project?.projectType)
}

function translateTo2DCoordinates(array1D: any[], numCols: number): { x: number, y: number }[] {
    const coordinates: { x: number, y: number }[] = [];
  
    array1D.forEach((item, idx) => {
        const x = idx; // col
        const y = Math.floor(idx / numCols); // row
        coordinates.push({ x, y, ...item });
    })
  
    return coordinates;
  }
  
export const FoldersMove: FC<{ 
    projects: Project[], 
    onDragProjects: (data: Project[]) => void, 
}> = ({ 
    projects, 
    onDragProjects 
}) => {
    const isMobile = useBreakpoint(LayoutConst.screen.s -1 ); 
    const isL = useBreakpoint(LayoutConst.screen.l)
    const is744 = useBreakpoint(LayoutConst.screen.s);
    const isTab = useBreakpoint(LayoutConst.screen.m);
    const is1280 = useBreakpoint(LayoutConst.screen.l_12)
    const isMac13 = useBreakpoint(LayoutConst.screen.mac13);

    const cols = useMemo(() => PROJECTS_COLUMNS_DESKTOP_COUNT, [])

    const padding = useMemo(() => {
        if (isMobile) {
            return LayoutConst.projectCardGap.s
        }
        if (isL) {
            return LayoutConst.projectCardGap.tablet
        }

        return LayoutConst.projectCardGap.l
    } , [isMobile, is744, LayoutConst, isTab, isL])

    const rowHeight = useMemo(() => {
        if (isMobile) {
            return LayoutConst.projectCard.m.h1_9; 
        }
        if (isTab) {
            return LayoutConst.projectCard.tablet.h;
        }
        if (isL) {
            return LayoutConst.projectCard.tablet.h;
        }

        return LayoutConst.projectCard.l.h
    } , [is744, isTab, isL, is1280, isMobile])

    const width = useMemo(() => {
        if (isMobile) {
            return window.innerWidth - 20;
        }
        if (isL) {
            return LayoutConst.container.xs
        }

        return LayoutConst.container.l
    } , [is744, isTab, isL, is1280, isMac13, isMobile]) 

    const gridOptions = useMemo(() => ({
        rowHeight,
        padding,
        cols,
        width
    }) , [rowHeight, cols, padding, is1280, isL, isMobile])

    const layout = useMemo(() => {
        const lay = projects?.map((project) => {
            return {
                i: project?.projectId,
                w: isWideProject(project) ? 2 : 1,
                h: 1,
                project
            }
        })
        return translateTo2DCoordinates(lay, PROJECTS_COLUMNS_DESKTOP_COUNT)
    } , [projects, cols, isMobile, rowHeight])

    return (
        <GridWithDifferentSizes layout={layout} onLayoutChange={onDragProjects} {...gridOptions}/>
    )
}import { Project } from "@brg/api";
import { FC, useMemo } from "react";
import { useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import GridWithDifferentSizes from "./components/GridWithDifferentSizes";
import { PROJECTS_COLUMNS_DESKTOP_COUNT } from "shared/pages/designer/components/DesignerFolders/DesignerFolders";

const isWideProject = (project: Project) => {
    //@ts-ignore
    return !!['fixed-ratio-small', 'fixed-ratio-large', 't-shape']?.includes(project?.projectType)
}

function translateTo2DCoordinates(array1D: any[], numCols: number): { x: number, y: number }[] {
    const coordinates: { x: number, y: number }[] = [];
  
    array1D.forEach((item, idx) => {
        const x = idx; // col
        const y = Math.floor(idx / numCols); // row
        coordinates.push({ x, y, ...item });
    })
  
    return coordinates;
  }
  
export const FoldersMove: FC<{ 
    projects: Project[], 
    onDragProjects: (data: Project[]) => void, 
}> = ({ 
    projects, 
    onDragProjects 
}) => {
    const isMobile = useBreakpoint(LayoutConst.screen.s -1 ); 
    const isL = useBreakpoint(LayoutConst.screen.l)
    const is744 = useBreakpoint(LayoutConst.screen.s);
    const isTab = useBreakpoint(LayoutConst.screen.m);
    const is1280 = useBreakpoint(LayoutConst.screen.l_12)
    const isMac13 = useBreakpoint(LayoutConst.screen.mac13);

    const cols = useMemo(() => PROJECTS_COLUMNS_DESKTOP_COUNT, [])

    const padding = useMemo(() => {
        if (isMobile) {
            return LayoutConst.projectCardGap.s
        }
        if (isL) {
            return LayoutConst.projectCardGap.tablet
        }

        return LayoutConst.projectCardGap.l
    } , [isMobile, is744, LayoutConst, isTab, isL])

    const rowHeight = useMemo(() => {
        if (isMobile) {
            return LayoutConst.projectCard.m.h1_9; 
        }
        if (isTab) {
            return LayoutConst.projectCard.tablet.h;
        }
        if (isL) {
            return LayoutConst.projectCard.tablet.h;
        }

        return LayoutConst.projectCard.l.h
    } , [is744, isTab, isL, is1280, isMobile])

    const width = useMemo(() => {
        if (isMobile) {
            return window.innerWidth - 20;
        }
        if (isL) {
            return LayoutConst.container.xs
        }

        return LayoutConst.container.l
    } , [is744, isTab, isL, is1280, isMac13, isMobile]) 

    const gridOptions = useMemo(() => ({
        rowHeight,
        padding,
        cols,
        width
    }) , [rowHeight, cols, padding, is1280, isL, isMobile])

    const layout = useMemo(() => {
        const lay = projects?.map((project) => {
            return {
                i: project?.projectId,
                w: isWideProject(project) ? 2 : 1,
                h: 1,
                project
            }
        })
        return translateTo2DCoordinates(lay, PROJECTS_COLUMNS_DESKTOP_COUNT)
    } , [projects, cols, isMobile, rowHeight])

    return (
        <GridWithDifferentSizes layout={layout} onLayoutChange={onDragProjects} {...gridOptions}/>
    )
}